export const MY_AVAILABILITY_SLICE = 'myAvailability' as const;
